const _ = require('lodash');

function Gtm($window, $injector, $timeout) {
    this._dataLayer = $window.dataLayer || [];
    this.$injector = $injector;
    this.$timeout = $timeout;
}

/**
 * Maps an object to an analytics event and pushes the event to the GTM queue.
 * @param {Object} data - An object which is used to populate the event.
 * @param {Function} [mapperFn] - A function which is used to map the data to a valid analytics event. If the mapper is
 *  an injectable function, it will be injected with its dependencies.
 */
Gtm.prototype.push = function (data, mapperFn) {
    this.$timeout(() => {
        this._dataLayer.push(this.mapData(data, mapperFn));
    });

    // allow chaining
    return this;
};

Gtm.prototype.mapData = function (data, mapperFn) {
    if (!mapperFn) {
        return data;
    }

    return mapperFn.$inject || _.isArray(mapperFn)
        ? this.$injector.invoke(mapperFn, null, { trackingData: data })
        : mapperFn(data);
};

Gtm.prototype.setDataLayer = function (dataLayer) {
    this._dataLayer = dataLayer;
    return this._dataLayer;
};

Gtm.prototype.isReadyToPush = function (data, mapperFn, index) {
    if (!_.isFunction(mapperFn)) return true;

    if (!data || !this._dataLayer) {
        return false;
    }

    return !this._isDataAtIndex(data, mapperFn, index);
};

Gtm.prototype._isDataAtIndex = function (data, mapperFn, index) {
    const lastData = this._dataLayer.slice(index).pop();
    if (!lastData) {
        // no data in dataLayer
        return false;
    }

    return _.isEqual(mapperFn(data), lastData);
};

module.exports = Gtm;



// WEBPACK FOOTER //
// ./src/olycommon/analytics/gtm/gtm.service.js